import React, { Component } from 'react'
import style from './EcomModuleDashboard.style'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../../wrapper/Wrapper'
import EcomModule from '../EcomModule'

class EcomModuleDashboard extends Component {
  render() {
    const { classes, showEcomError } = this.props

    return (
      <Wrapper
        shadow={1}
        style={{
          borderRadius: 8,
          overflow: 'hidden',
          padding: '20px 16px 32px 20px',
          backgroundColor: 'rgb(255, 255, 255)',
          marginTop: 32,
        }}
      >
        <header className={classes.header}>
          <Typography className={classes.title}>
            Электронная торговля
          </Typography>
        </header>

        <EcomModule
          headerClass={[classes.reverse]}
          wrapperClass={[classes.full]}
          showEcomError={showEcomError}
        />
      </Wrapper>
    )
  }
}

export default style(EcomModuleDashboard)
